// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Hk363","label":"CategoryService_label__mlfoK","location":"CategoryService_location__3SY3h"};